<template lang="pug">
  div.animated.fadeIn
    b-card
      div.row
        div.col-sm-12
          h4.col-title.mb-0
            | NLU Studio
          div.small.text-muted
            | Displaying a List of Intents
      br
      b-card
        div.row
          div.col-sm-6
            b-form-group(horizontal label='Search')
              b-input-group
                b-form-input(v-model='filter' placeholder='Type to Search...')
                b-btn(:disabled='!filter' @click='filtersearch' style='border-radius:0 0.25rem 0.25rem 0;')
                  | Clear
          div.col-sm-6
            b-button.pull-right.ml-3(type='button', variant='primary', @click='toggleIntentEditor' v-if='!EditorIsOpened')
              | &nbsp;Open Editor
            b-button.pull-right.ml-3(type='button', variant='primary', @click='toggleIntentEditor' v-else)
              | &nbsp;Close Editor
            //- b-button.pull-right.ml-1(type='button', variant='primary', @click='openUploadModal = true')
            //-   i.icon-cloud-download
            //-   | &nbsp;Import
            b-modal(v-model='openUploadModal', title='Import Excel', ok-title='Upload', @ok='uploadXLSX' lazy)
              b-form-file(v-model='xlsxFile', placeholder='Place a xlsx file...' no-drop=true)
      intent-table(:data='tableItems', :label='tableFields')

</template>

<script>
// TODO:
// - check the type of responses that are available in an intent categorized by carousel, text, image
// - Implement the filter search functions.
// - Cater for image responses
// - Cater for card responses
// - Cater for Custom payload responses
// - Retype the code for format of the table when uploading excel file.
// - Implement check box on the id
// - Implement pagination for the table (able to search up throught the paginationbu)
// - Convert quick replies into bubbles in the tables.
// - Implement versioning interface (priority: low)
// - Find a more efficient way to search up the data in elasticsearch (Limited amount of data to be searched up: 10000)

import xlsx from 'xlsx'
import moment from 'moment'
// import elasticsearch from 'elasticsearch'
import { getDFIntents, deleteDFIntents } from '@/api'

// var esclient = new elasticsearch.Client({
//   host: 'https://search-cibank-ajuzav2ibzmurfjngw3tdxmmt4.us-east-2.es.amazonaws.com',
// })

// esclient.cluster.health({}, function(error, response, status) {
//   console.log('-- Client Health --', { response })
//   if (error) {
//     console.log({ error })
//   }
// })

export default {
  name: 'IntentsList',
  data() {
    return {
      EditorIsOpened: false,
      esIndex: 'dialogflow',
      esType: 'intents',
      esDataSize: 0,
      filter: null,
      loadingText: 'Loading...',
      loading: true,
      openUploadModal: false,
      openExportModal: false,
      xlsxFile: null, // contain data of the imported files
      xlsxForDownload: [], // stores data tthat allows user to download
      bulkBody: [], // storing data by index and value in a body for elastic search
      listOfIntents: [],
      listOfAllQuickReply: [],
      intentsExist: false, // check whether intents exist in elasticsearch db
      tableItems: [],
      tableFields: {
        intentId: {
          label: 'No',
          sortable: true,
          thStyle: {
            width: '100px',
          },
        },
        intentTitle: {
          label: 'Intents',
          sortable: true,
          thStyle: {
            width: '400px',
          },
        },
        answerType: {
          label: 'Type of Answer',
        },
        // intentAnswers: {
        //   label: 'Answers',
        //   thStyle: {
        //     width: '600px'
        //   }
        // },
        noOfTrainings: {
          label: '# of Utterances',
        },
        quickReplies: {
          label: 'Quick Replies',
        },
        actions: {
          label: '<i></i>',
        },
        // show_details: {
        //   label: 'Details'
        // }
      },
    }
  },
  watch: {
    // if there is new intent, add new intent into table.
    '$store.state.newIntents'() {
      this.EditorIsOpened = false
      this.tableItems.unshift(this.$store.state.newIntents)
    },
    '$store.state.newEditedIntent'() {
      // delete the index in elastsicsearch db.
      // get the updated list of intent from dialogflow again
      const that = this
      console.log(this.$store.state.newEditedIntent)
      this.tableItems = []
      getDFIntents().then((response) => {
        if (response.status === 200) {
          that.displayIntents()
        }
      })
    },
    '$store.state.asideStatus'() {
      this.EditorIsOpened = this.$store.state.asideStatus
    },
    // Any intent that was clicked with remove button will be removed from both dialogflow and elasticsearch db.
    '$store.state.removeIntent'() {
      const that = this
      this.tableItems = this.tableItems.filter(function(item) {
        return item !== that.$store.state.removeIntent
      })
      // intent full id consist dialogflow id that will be removed in the server.
      const intent = { intentFullId: this.$store.state.removeIntent.intentFullId }
      deleteDFIntents(intent).then(
        (response, error) => {
          if (response) {
            console.log(response)
          } else {
            console.log(error)
          }
        })
      // remove intent name based on its id set in elasticsearch db
      // esclient.delete({
      //   index: this.esIndex,
      //   type: 'intents',
      //   id: this.$store.state.removeIntent.intentId,
      // }, function(response, error, status) {
      //   if (response) {
      //     console.log('Delete Successful', response)
      //   } else if (error) {
      //     console.log('Unable to Delete in ES db', error)
      //   } else {
      //     console.log('Delete completed with errors!', status)
      //   }
      // })
    },
    filter() {
      // Provide functionality to search
      // const that = this
      // esclient.search({
      //   index: `${that.esIndex}`,
      //   type: `${that.esType}`,
      //   size: that.esDataSize,
      //   body: {
      //     query: {
      //       'multi_match': {
      //         'query': that.filter,
      //       },
      //     },
      //   },
      // }, function (error, response, status) {
      //   if (error) {
      //     console.log('There is a search error', { error })
      //   } else {
      //     let searchedTable = []
      //     response.hits.hits.forEach(function(hit) {
      //       searchedTable.push(hit._source)
      //     })
      //     if (that.filter === '') {
      //       that.tableItems = that.listOfIntents
      //     } else {
      //       that.tableItems = searchedTable
      //     }
      //   }
      // })
    },
  },
  methods: {
    clearTable: function() {
      this.tableItems = []
    },
    toggleIntentEditor: function() {
      // opens/close the intent editor
      // Sets the action of intent which is create new intent
      // set whether the aside div is hidden or shown.
      if (this.EditorIsOpened) {
        this.$store.dispatch('setAsideStatus', false)
      } else {
        this.$store.dispatch('setAsideStatus', true)
        this.$store.dispatch('setActionInIntentPage', 'Create Intent')
      }
      document.body.classList.toggle('aside-menu-hidden')
    },
    filtersearch: function() {
      this.filter = null
    },
    uploadXLSX: function() {
      if (window.FileReader) {
        const that = this
        // To read the excel files
        var reader = new FileReader()
        reader.onload = function(e) {
          var data = e.target.result
          // Read Excel in terms of binary data
          const workbook = xlsx.read(data, { type: 'binary' })
          const worksheets = workbook.SheetNames
          console.log(workbook)
          // Convert Excel to json object
          const rows = xlsx.utils.sheet_to_json(workbook.Sheets[worksheets[0]], { raw: false })
          // Declaring array for table contents
          that.listOfIntents = []
          // Declaring array for list of checkbox
          var listOfQuestions = []
          var listOfQuickReply = []
          // Declaring variables for intent No, title and answers
          var intentIndex
          var intentTitle
          var intentAnswers
          // Delcaring variables for number of utterances and number of bubble
          var noOfUtterance = 0
          var noOfBubble = 0

          rows.forEach(function(rowObject, index) {
            // if index exist in excel which means new intents or end of excel list
            if ((rowObject['No'] && index !== 0) || index + 1 === rows.length) {
              // Create Unique IDs for indexing with elasticsearch
              // let uniqueID = Math.random().toString(36).substr(2, 16)

              // whenever intent number exist, it shows that it is a new intent title.
              // push the previous intent information such as its title, questions, answers, utterances, number of quick replies and a bolean of answercollapse
              that.listOfIntents.push({
                // index: uniqueID,
                intentNo: intentIndex,
                intentTitle: intentTitle,
                intentQuestions: listOfQuestions,
                intentAnswers: intentAnswers,
                quickReplies: listOfQuickReply,
                utterance: noOfUtterance || 0,
                noOfBubble: noOfBubble || 0,
                answerCollapseIs: false, // Boolean to check if the answer is collapsed in the table.
              })
              that.bulkBody.push({
                index: {
                  _index: 'intents',
                  _type: 'FAQ',
                  _id: intentIndex,
                },
              }, {
                intentNo: intentIndex,
                intentTitle: intentTitle,
                intentQuestions: listOfQuestions,
                intentAnswers: intentAnswers,
                quickReplies: listOfQuickReply,
                utterance: noOfUtterance || 0,
                noOfBubble: noOfBubble || 0,
                answerCollapseIs: false, // Boolean to check if the answer is collapsed in the table.
              })
              // Reset the array of Questions and quick replies, same goes to number of utterances and number of bubble.
              listOfQuestions = []
              listOfQuickReply = []
              noOfUtterance = 0
              noOfBubble = 0
            }
            // Check if No exist in the object
            if (rowObject['No']) {
              intentIndex = rowObject['No']
            }
            // Check if Intent title exist in the object
            if (rowObject['Intents']) {
              intentTitle = rowObject['Intents']
            }
            // Check if Answer exist in the object
            if (rowObject['Answers']) {
              intentAnswers = rowObject['Answers']
            }
            // format to use the checkbox by pushing {text: , value: } into array
            if (rowObject['Bubble Suggestion']) {
              listOfQuickReply.push({
                text: rowObject['Bubble Suggestion'],
                value: { index: rowObject['Bubble Suggestion'] },
              })
              noOfBubble = listOfQuickReply.length
            }
            if (rowObject['Questions / Triggering Bubble']) {
              listOfQuestions.push({
                text: rowObject['Questions / Triggering Bubble'],
                value: { index: rowObject['Questions / Triggering Bubble'] },
              })
              noOfUtterance = listOfQuestions.length
            }

            // Add data to the array that is meant to be downloaded.
            that.xlsxForDownload.push({
              intentNo: rowObject['No'] || '',
              intentTitle: rowObject['Intents'] || '',
              intentQuestions: rowObject['Questions / Triggering Bubble'] || '',
              intentAnswers: rowObject['Answers'] || '',
              quickReplies: rowObject['Bubble Suggestion'] || '',
            })
          })
          that.tableItems = that.listOfIntents
          console.log('this is the list of intents')
          console.log(that.tableItems)
          console.log('bulkBody exist?', that.bulkBody)
          // esclient.bulk({
          //   maxRetries: 5,
          //   index: 'intents',
          //   type: 'FAQ',
          //   body: that.bulkBody,
          // }, function(error, response, status) {
          //   if (error) {
          //     console.log('Oh shit! Got Error while bulking', error)
          //   } else {
          //     console.log(' The response from here: ')
          //     console.log(response)
          //     console.log('\n')
          //   }
          //   console.log('Current status of bulking', status)
          // })
        }
        reader.readAsBinaryString(this.xlsxFile)
      }
    },
    downloadXLSX: function() {
      // cater empty download array
      if (this.xlsxForDownload.length === 0) {
        this.$snotify.error('Sorry there is nothing to export.')
      } else {
        var worksheet = xlsx.utils.json_to_sheet([
          { A: 'No', B: 'Intents', C: 'Questions / Triggering Bubble', D: 'Answers', E: 'Bubble Suggestion' }], { header: ['A', 'B', 'C', 'D', 'E', 'F'], skipHeader: true })
        this.xlsxForDownload.forEach(function(rowObject, index) {
          xlsx.utils.sheet_add_json(worksheet, [
            {
              A: rowObject.intentNo,
              B: rowObject.intentTitle,
              C: rowObject.intentQuestions,
              D: rowObject.intentAnswers,
              E: rowObject.quickReplies,
            }], {
            header: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
            skipHeader: true,
            origin: -1,
          })
        })
        const workbook = { SheetNames: ['Intent List'], Sheets: { 'Intent List': worksheet } }
        const date = moment(new Date()).format('YYYYMMDD')
        const fileName = `imSME_FAQ_IntentList_${date}.xlsx`
        xlsx.writeFile(workbook, fileName)
      }
    },
    displayIntents: function() {
      // const that = this
      // Count the number of data to know the total amount of data that are needed to be searched up in the search function
      // esclient.count({
      //   index: that.esIndex,
      // }).then((response) => {
      //   that.esDataSize = response.count
      //   // Get all data from elasticsearch database
      //   esclient.search({
      //     index: that.esIndex,
      //     type: that.esType,
      //     size: that.esDataSize,
      //     version: true,
      //     body: {
      //       query: {
      //         'match_all': {}, // Putting it empty so it will return all data
      //       },
      //     },
      //   }, (error, response, status) => {
      //     // Callback to cater error and take in the response
      //     if (error) {
      //       console.log('An error occur during search:', { error })
      //     } else {
      //       // Iterate through the list of objects and add into the table.
      //       // console.log(response.hits.hits)
      //       that.listOfIntents = []
      //       that.listOfAllQuickReply = []
      //       response.hits.hits.forEach(function(hit, index) {
      //         hit._source.actions = hit._source
      //         that.listOfIntents.push(hit._source)
      //         if (hit._source.quickReplies !== 'None') {
      //           that.listOfAllQuickReply = that.listOfAllQuickReply.concat(hit._source.quickReplies)
      //         }
      //       })
      //       // Creates distinct element in quick reply array
      //       that.listOfAllQuickReply = [...new Set(that.listOfAllQuickReply)].filter((item) => {
      //         return item !== undefined
      //       })
      //       // Remove any undefined quick reply in quick reply array
      //       // Not sure why though, need to reinvestigate on how data was massaged in the server
      //       that.listOfAllQuickReply = that.listOfAllQuickReply.map(function(item) {
      //         return { value: item, text: `${item}` }
      //       })
      //       // Set list of distinct quick reply  as a state in vuex so it can be used in the intent editor page.
      //       this.$store.dispatch('setListOfAllQuickReplies', that.listOfAllQuickReply)
      //       that.tableItems = that.listOfIntents
      //     }
      //   })
      // })
    },
  },
  mounted: async function () {
    const that = this
    // delete the index in elastsicsearch db.
    // get the updated list of intent from dialogflow again
    // await esclient.indices.delete({
    //   index: this.esIndex,
    // }, function(error, response, status) {
    //   if (error) {
    //     console.log('Unable to delete dialogflow index', error)
    //   } else if (response) {
    //     console.log('Reset elasticsearch db based on dialogflow updates successful', response)
    //   }
    // })
    await getDFIntents().then((response) => {
      if (response.status === 200) {
        that.displayIntents()
      }
    })
  },
  beforeDestroy() {
    // disable the side bar after user leave the page.
    if (document.getElementsByClassName('aside-menu-hidden').length === 0) {
      document.body.classList.toggle('aside-menu-hidden')
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Intents/IntentsList.vue?59c1566e